import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as myGlobals from '../app.component';

@Injectable({
  providedIn: 'root'
})
export class InstituteService {


  private baseUrl = myGlobals.baseUrl;

  constructor(private http: HttpClient) { }

  submitNodalOfficerDetails(data) {
    return this.http.post(`${this.baseUrl}/submitNodalOfficerDetails`, data);
  }

  submitAssistantCordinatorDetails(data) {
    return this.http.post(`${this.baseUrl}/submitAssistantCordinatorDetails`, data);
  }

  getNodalDetails() {
    return this.http.get(`${this.baseUrl}/GetNodalDetail`);
  }

  getInstituteType() {
    return this.http.get(`${this.baseUrl}/getInstituteType`);

  }
  getAssistantCoordinatorDetails() {
    return this.http.get(`${this.baseUrl}/GetAssistantCordinatorDetail`);
  }

  getInstituteDetails() {
    return this.http.get(`${this.baseUrl}/getInstituteDetails`);
  }

  submitPrincipalDetails(data) {
    return this.http.post(`${this.baseUrl}/submitPrincipalDetails`, data);
  }

  getPrincipalDetails() {
    return this.http.get(`${this.baseUrl}/getPrincipalDetails`);
  }

  getCourseDetails() {
    return this.http.get(`${this.baseUrl}/getCourseDetails`);
  }

  updateCourseDetails(data) {
    return this.http.post(`${this.baseUrl}/updateCourseDetails`, data);
  }

  addStudent(data) {
    return this.http.post(`${this.baseUrl}/addInstituteStudent`, data);
  }

  getInstituteStudents() {
    return this.http.get(`${this.baseUrl}/getInstituteStudent`);
  }

  deleteInstituteStudent(data) {
    return this.http.post(`${this.baseUrl}/deleteInstituteStudent`, data);
  }

  getDesignations() {
    return this.http.get(`${this.baseUrl}/getDesignations`);
  }

  getExaminationDetails() {
    return this.http.get(`${this.baseUrl}/getExaminationDetails`);
  }

  submitExaminationDetails(data) {
    return this.http.post(`${this.baseUrl}/submitExaminationDetails`, data);
  }

  getInstituteFaculty() {
    return this.http.get(`${this.baseUrl}/getInstituteFaculty`);
  }

  deleteInstituteFaculty(data) {
    return this.http.get(`${this.baseUrl}/deleteInstituteFaculty?id=` + data);
  }

  submitInstituteFaclty(data) {
    return this.http.post(`${this.baseUrl}/submitInstituteFaclty`, data);
  }

  submitInstituteDetailsFinal() {
    return this.http.get(`${this.baseUrl}/submitInstituteFinal`);
  }

  registerInstitute(data) {
    return this.http.post(`${this.baseUrl}/registerInstitute`, data);
  }

  addInstituteCourse(data) {
    return this.http.post(`${this.baseUrl}/addInstituteCourse`, data);
  }

  getStudents() {
    return this.http.get(`${this.baseUrl}/getStudents`);
  }
  getState() {
    return this.http.get(`${this.baseUrl}/getRegisterState`);
  }
  getDistrict(data) {
    return this.http.get(`${this.baseUrl}/getRegisterDistrict?state_id=${data}`);
  }
  makeEligible(data) {
    return this.http.post(`${this.baseUrl}/makeEligible`, data);
  }
  makeHodEligible(data: any) {
    return this.http.post(`${this.baseUrl}/makeHodEligible`, data);
  }
  makeFacultyEligible(data: any) {
    return this.http.post(`${this.baseUrl}/makeFacultyEligible`, data);
  }
  getInstTypes() {
    return this.http.get(`${this.baseUrl}/getAllInstType`);
  }

  updateInstituteDetails(data) {
    return this.http.post(`${this.baseUrl}/updateInstituteDetails`, data);
  }

  getInstituteDepartment() {
    return this.http.get(`${this.baseUrl}/getInstituteDepartment`);
  }

  getInstituteEligibleType() {
    return this.http.get(`${this.baseUrl}/getInstituteEligibleType`);
  }

  getUserData() {
    return this.http.post(`${this.baseUrl}/getUser`, null);
  }

  facultyLeftInstitute(data) {
    return this.http.post(`${this.baseUrl}/facultyLeftInstitute`, data);
  }

  studentLeftInstitute(data) {
    return this.http.post(`${this.baseUrl}/studentLeftInstitute`, data);
  }

  getDepartmentByProgrammeLevel(programme, level) {
    return this.http.get(`${this.baseUrl}/getDepartmentByProgrammeLevel?programme=${programme}&level=${level}`);
  }

  getCourseByLevelDepartment(programme, level, department) {
    return this.http.get(`${this.baseUrl}/getCourseByLevelDepartment?programme=${programme}&level=${level}&department=${department}`);
  }

  getCourseByDeptDetails(department) {
    return this.http.get(`${this.baseUrl}/getCourseByDeptDetails?department=${department}`);
  }

  getInstitutesRegList() {
    return this.http.get(`${this.baseUrl}/getInstitutesRegList`);
  }

  getSelectedDepartmentStudents(data, level, assessmentGap) {
    return this.http.get(`${this.baseUrl}/getSelectedDepartmentStudents?departments=${data}&levels=${level}&gap=${assessmentGap}`);
  }

  getDepartment() {
    return this.http.get(`${this.baseUrl}/getDepartment`);
  }

  updateStudentDates(data) {
    return this.http.post(`${this.baseUrl}/updateStudentDates`, data);
  }

  getStudentAssessmentInstDashCounts() {
    return this.http.get(`${this.baseUrl}/getStudentAssessmentInstDashCounts`);
  }

  getStudentAssessmentDetailsInstDashCounts() {
    return this.http.get(`${this.baseUrl}/getStudentAssessmentDetailsInstDashCounts`);
  }

  instituteApplicationPrint(){
    return this.http.get(`${this.baseUrl}/instituteApplicationPrint`);
  }

  getAllMessages(data) {
    return this.http.get(`${this.baseUrl}/getAllMessages?role_id=`+data);
  }

  getStudentForVerification(){
    return this.http.get(`${this.baseUrl}/getStudentForVerification`);
  }

  studentVerification(id,status){
    return this.http.get(`${this.baseUrl}/studentVerification?id=${id}&status=${status}`);
  }

  updateStudentStatus(id){
    return this.http.post(`${this.baseUrl}/updateStudentStatus`, id);
  }
  
  updateFacultyStatus(id){
    return this.http.post(`${this.baseUrl}/updateFacultyStatus`, id);
  }

  getAisheDetails(aishe_code){
    return this.http.get(`${this.baseUrl}/getAisheDetails?aishe_code=`+aishe_code);
  }

  // Parakh Institute Details dashboard
  getParakhInstituteDetails(data) {
    return this.http.post(`${this.baseUrl}/getParakhInstituteDetails`,data);
  }

  getDistrictByMultiStates(data){
    return this.http.get(`${this.baseUrl}/getDistrictByMultiStates?states=`+data);
  }
}
